const MOBILE_BREAKPOINT = 768;

function getPerPage() {
	return window.innerWidth < MOBILE_BREAKPOINT ? 1 : 3;
}

function initSlider(section) {
	const track = section.querySelector('.diakon-slider__track');
	const nav = section.querySelector('.diakon-slider__nav');

	if (!track || !nav) {
		return;
	}

	const slides = Array.from(
		track.querySelectorAll(':scope > .wp-block-column')
	);
	if (!slides.length) {
		return;
	}

	const prevBtn = nav.querySelector('.diakon-slider__prev');
	const nextBtn = nav.querySelector('.diakon-slider__next');
	const dotsContainer = nav.querySelector('.diakon-slider__dots');

	let currentPage = 0;

	function totalPages() {
		return Math.ceil(slides.length / getPerPage());
	}

	function buildDots() {
		dotsContainer.innerHTML = '';
		for (let i = 0; i < totalPages(); i++) {
			const btn = document.createElement('button');
			btn.className = 'diakon-slider__dot';
			btn.type = 'button';
			btn.setAttribute('aria-label', `Sivu ${i + 1}`);
			btn.addEventListener('click', () => goTo(i));
			dotsContainer.appendChild(btn);
		}
	}

	function goTo(page) {
		const total = totalPages();
		currentPage = Math.max(0, Math.min(page, total - 1));

		const perPage = getPerPage();
		const start = currentPage * perPage;

		slides.forEach((slide, i) => {
			slide.classList.toggle(
				'is-slide-active',
				i >= start && i < start + perPage
			);
		});

		dotsContainer
			.querySelectorAll('.diakon-slider__dot')
			.forEach((dot, i) => {
				dot.classList.toggle('is-active', i === currentPage);
				dot.setAttribute('aria-current', String(i === currentPage));
			});

		if (prevBtn) {
			prevBtn.disabled = currentPage === 0;
		}
		if (nextBtn) {
			nextBtn.disabled = currentPage >= total - 1;
		}

		nav.hidden = total <= 1;
	}

	if (prevBtn) {
		prevBtn.addEventListener('click', () => goTo(currentPage - 1));
	}
	if (nextBtn) {
		nextBtn.addEventListener('click', () => goTo(currentPage + 1));
	}

	let lastPerPage = getPerPage();

	window.addEventListener(
		'resize',
		() => {
			const newPerPage = getPerPage();
			if (newPerPage !== lastPerPage) {
				lastPerPage = newPerPage;
				currentPage = 0;
				buildDots();
				goTo(0);
			}
		},
		{ passive: true }
	);

	section.classList.add('is-slider-ready');
	buildDots();
	goTo(0);
}

export function initSliders() {
	document.querySelectorAll('.diakon-slider-section').forEach(initSlider);
}
